import { cn } from '../utils';

export interface TabItem {
  id: string;
  label: string;
}

export interface TabBarProps {
  tabs: TabItem[];
  active: string;
  onChange: (id: string) => void;
  extraTabs?: TabItem[];
  className?: string;
}

export function TabBar({ tabs, active, onChange, extraTabs, className }: TabBarProps) {
  const allTabs = extraTabs ? [...tabs, ...extraTabs] : tabs;

  return (
    <nav
      aria-label="Tabs"
      className={cn('flex gap-1 border-b border-[var(--color-border)]', className)}
    >
      {allTabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              'relative inline-flex items-center px-3 py-2 text-[13px] transition-colors',
              'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]',
              isActive && 'font-medium text-[var(--color-text-primary)]',
              isActive &&
                "after:absolute after:left-0 after:right-0 after:-bottom-px after:h-[2px] after:bg-[var(--color-accent)] after:content-['']",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
